import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory, useParams, useLocation } from "react-router-dom";
import useFetch from '../../useFetch';
import { Row, Col, Container } from 'react-bootstrap';
import { cleanUp } from '../../Services/Utilities.js';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { getAbbrPiByID, getDrugInfo} from '../../Services/ProductSearchService.js'
import Modal from 'react-bootstrap/Modal';
import { IconSearch, IconUserSquareRounded,IconPillFilled, IconInfoCircleFilled,IconListSearch, IconCaretDownFilled, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, Select, InputLabel, Skeleton, CircularProgress, Accordion, AccordionSummary, ButtonGroup, AccordionDetails, TextField, Link, Checkbox,Collapse, Divider, InputAdornment, ListItemButton, ListSubheader, Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../../styles/DosingCalculations.scss'
import { logPageViews } from '../../Services/LoginService.js';
import Illustration from '../../assets/ModuleIllustrations/DoseCalculation.svg';
import IllustrationNZ from '../../assets/ModuleIllustrations/NZ/DoseCalculation.svg';
import Drugs4DentLogo from '../../assets/Drugs4dent.svg';
import { useThemeManager } from '../../Context/ThemeManager.js';

const DosingCalculations = () => {
    const { theme} = useThemeManager();
    const [activeButton, setActiveButton] = useState('dosing');
    const history = useHistory();
    const { error, isPending, data } = useFetch('api/MimsDrug4dent/GetDosingCalculationDrugName') //data set
    const [optiDCDrugNameon, setDCDrugName] = useState()
    const [PatientClassification, setPatientClassification] = useState([])
    const [doseId, setDoseId] = useState(undefined)
    const [vpName, setvpName] = useState('')
    const { id: idFromUrl } = useParams();
    const id = Number(idFromUrl);
    const [isModalDataLoading, setIsModalDataLoading] = useState(false)
    const isLgScreen = useMediaQuery('(min-width:1024px)');
    const country = localStorage.getItem("Activecountryversion");

    useEffect(() => {
        document.title = "Dosing Calculations"
        document.documentElement.style.setProperty('--primary-color', theme.primary);
        document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
        document.documentElement.style.setProperty('--bg', theme.bg);

    }, [])
    function showLoader() {
      const el = document.getElementById("loader");
      if (el) {
        console.log("Before:", el.style.display);
        el.style.setProperty("display", "flex", "important");
        el.style.zIndex = "1000";
        console.log("After:", el.style.display);
      }
    }
    
      
      function hideLoader() {
        const el = document.getElementById("loader");
        if (el) {
          el.style.display = "none";
        }
      }

      if (isPending) {
        document.getElementById('loaderPage').style.display = 'flex'
    } else {
        document.getElementById('loaderPage').style.display = 'none'
    }
      //Step 0: filter data first
    const excludedDrugs = [
        'Amitriptyline', 'Amphotericin', 'Articaine with/without adrenaline', 'Carbamazepine',
        'Lidocaine with/without adrenaline', 'Mepivacaine with/without adrenaline',
        'Methoxyflurane', 'Nitrous oxide', 'Oxcarbazepine',
        'Prilocaine with felypressin', 'Prilocaine with/without adrenaline'
      ];
      
    const filteredOptions = data.filter(val => !excludedDrugs.includes(val.name));
    const [isLoading, setIsLoading] = useState(true);
    const [selectedDrug, setSelectedDrug] = useState(null); // new
    
    //Step 1
    const hasHandledIdRef = useRef(false); //prevent multiple async triggers
    
    useEffect(() => {
      
    
      if (data.length === 0 || filteredOptions.length === 0 || hasHandledIdRef.current) {
        
        return;
      }
    
      const selectedFromUrl = id !== undefined
        ? filteredOptions.find(e => e.id === id)
        : undefined;
    
      const selectedFromState = doseId !== undefined
        ? filteredOptions.find(e => e.id === doseId)
        : undefined;
    
      if (selectedFromUrl && !doseId) {
        handleDoseSelection(selectedFromUrl); // hideLoader will run from inside this
        setSelectedDrug(selectedFromUrl);
        hasHandledIdRef.current = true;
      } else if (selectedFromState && id === undefined) {
        handleDoseSelection(selectedFromState); // same here
        hasHandledIdRef.current = true;
      } else {
      }
    
      setIsLoading(false);
    }, [data, filteredOptions]);
    
    
      // Scroll window to fit drug list and patient classification container
      const handleScrollDosing = () => {
        window.scrollTo({
          top: 164,
          behavior: 'smooth'
        });
      };


      const handleDoseSelection = async (selected) => { 
        if (!selected) return;
      
        setDoseId(selected.id);
        setvpName(selected.name ?? '');
        setIsLoading(false);
    
        const selectedDrug = data.find(e => e.id == selected.id);
        setvpName(selectedDrug?.name ?? '');
        history.push('/dosingcalculations/' + selected.id);
        showLoader();    
        let tempDrug = null; // Declare outside so it's accessible later
        setIsDataLoading(true);
        setSelectedPatient(null);
        try {
            const res = await fetch(
                process.env.REACT_APP_APIDrug4dents_URL +
                'api/MimsDrug4dent/GetDosingCalculationPatientClassification?drugName=' + selected.id,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('sessionId')?.replaceAll('"', '')} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`,
                    },
                }
            );
    
            const result = await res.json();
            setPatientClassification(result);
            setadminRoute('');
            setShowGuideline(false);
    
            tempDrug = result[0];
            setSelectedDrug(tempDrug);
            console.log("Selected Drug holder: ", tempDrug);
    
            if (result.length > 0) {
                setSelectedPatient(tempDrug);
                setTimeout(() => {
                    handleScrollDosing();
                }, 100);
            }
    
            await logPageViews('Dosing', tempDrug?.name ?? '');
        } catch (err) {
            console.error("Token check error:", err);
        } finally {
            hideLoader();
            setIsDataLoading(false);
        }
    
        // Preload precaution/contraindication
        if (tempDrug) {
            const precautionCleaned = cleanUp(tempDrug?.precaution);
    
            if (!tempDrug?.brandId) {
                setModalBody(precautionCleaned);
                setIsModalDataLoading(false);
            } else {
                setIsModalDataLoading(true);
                try {
                    const info = await getDrugInfo(tempDrug.brandId);
    
                    if (info?.statusChanged === "Deleted") {
                        setModalBody(precautionCleaned);
                    } else if (info?.abbreviatedPi) {
                        const pi = await getAbbrPiByID(info.abbreviatedPi.abbreviatedPiId);
    
                        if (pi?.content) {
                            const sections = [];
    
                            pi.content.forEach((e) => {
                                if (e.header === "Contraindications" && e.text !== "") {
                                    sections.push(
                                        <div key="contraindications">
                                            <h5>Contraindications:</h5>
                                            <div>{e.text}</div>
                                            <br />
                                        </div>
                                    );
                                }
    
                                if (e.header === "Precautions" && e.text !== "") {
                                    sections.push(
                                        <div key="precautions">
                                            <h5>Precautions:</h5>
                                            <div>{e.text}</div>
                                        </div>
                                    );
                                }
                            });
    
                            setModalBody(<>{sections}</>);
                        }
                    }
                } catch (error) {
                    console.error("Error preloading precaution data:", error);
                    setModalBody(precautionCleaned); // fallback
                } finally {
                    setIsModalDataLoading(false);
                }
            }
        }
    };
    
    
    
   
     
  
    // Group patient categories by their longest similar prefix
    const normalize = (text) =>
      text.toLowerCase()
        .replace(/[^a-z0-9()<=\s.-]/gi, '') 
        .replace(/\s+/g, ' ')
        .trim();
    
    const tokenize = (text) => normalize(text).split(' ');
    
    const longestCommonPrefix = (tokensA, tokensB) => {
      const length = Math.min(tokensA.length, tokensB.length);
      let prefix = [];
      for (let i = 0; i < length; i++) {
        if (tokensA[i] === tokensB[i]) {
          prefix.push(tokensA[i]);
        } else {
          break;
        }
      }
      return prefix.join(' ');
    };
    
    const groupPatientCategories = (data) => {
      const groups = {};
      const labelLookup = {}; // map normalized groupKey => best original label
    
      data.forEach((item, i) => {
        const tokensA = tokenize(item.patientCaterory);
        let bestPrefix = '';
        let matchLabel = '';
    
        for (let j = 0; j < data.length; j++) {
          if (i === j) continue;
    
          const tokensB = tokenize(data[j].patientCaterory);
          const prefix = longestCommonPrefix(tokensA, tokensB);
    
          if (prefix && prefix.length > bestPrefix.length) {
            bestPrefix = prefix;
    
            // Extract clean original label from actual text
            const escapeRegex = (str) =>
              str.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    
            const pattern = bestPrefix
              .split(" ")
              .map(escapeRegex)
              .join(".*?");
            const regex = new RegExp(pattern, "i");
    
            const match = item.patientCaterory.match(regex);
            matchLabel = match ? match[0] : '';
          }
        }
    
        // Fallback: just normalize the item
        let groupKey = bestPrefix ? bestPrefix : normalize(item.patientCaterory);
        groupKey = groupKey.toUpperCase();
    
        // Use first matching original string for display
        if (!labelLookup[groupKey]) {
          let label = matchLabel || item.patientCaterory;
    
          // Normalize formatting
          if (label.includes('(') && !label.includes(')')) {
            label += ')';
          }
          if (label.endsWith(':')) {
            label = label.slice(0, -1);
          }
    
          labelLookup[groupKey] = label.toUpperCase(); // Final subheader label
        }
    
        const displayLabel = labelLookup[groupKey];
    
        if (!groups[displayLabel]) {
          groups[displayLabel] = [];
        }
    
        groups[displayLabel].push(item);
      });
    
      return groups;
    };
    
  
    const groupedPatients = groupPatientCategories(PatientClassification);

    // Patient classification change handler
    function handlePatientClassificationChange(patient) {
        // Start loading
        setIsDataLoading(true);
        // Set the selected patient
        setSelectedPatient(patient);
        // Simulate async operation (e.g., fetching data)
        setTimeout(() => {
            // Once the data is ready, stop loading
            setIsDataLoading(false);
        }, 500); // Simulate .5-second loading
    }
    
    const [modalTitle, setModalTitle] = useState('')
    const [modalBody, setModalBody] = useState('')
    const [footerButtonType, setFooterButtonType] = useState(null);
    const [modalLogo, setModalLogo] = useState(null); // initialize as null, since it will store a JSX element
    const drugs4DentLogoElement = (
      <img
        src= {Drugs4DentLogo}
        id="logo-img"
        alt="Logo"
        className="me-2"
        style={{ maxWidth: isLgScreen ? "140px" : "120px", height: "auto" }}
      />
    );
    const handleFooterButtons = (buttonType) => {
        
        const calculationsLogo = (
            <IconInfoCircleFilled size={20} style={{ marginRight: 8, verticalAlign: "middle", color: theme.primary }} />
        );

        setFooterButtonType(buttonType);

        if (buttonType === 0) {
          if (isLgScreen) {
              handleRedirect(); // ✅ Call the function
              return;
          } else {
              setModalLogo(drugs4DentLogoElement);
              setModalTitle("Interaction Checker");
              setShowFooterButtonModal(true);
          }
      }
        else if (buttonType === 1) {
            setModalLogo(drugs4DentLogoElement); // Set JSX element for the logo
            setModalTitle("Contraindication & Precaution");
            setShowFooterButtonModal(true);
        } 
        else if (buttonType === 2) {
            setModalLogo(drugs4DentLogoElement); // Set JSX element for the logo
            setModalTitle("Pregnancy & Lactation");
            setShowFooterButtonModal(true);
            console.log("pregnancy");
        }
        else if (buttonType === 3) {
            setModalLogo(calculationsLogo); // Set JSX element for the logo
            setModalTitle("Dose Calculation");
            setShowFooterButtonModal(true);
            console.log("dose calculation");
        }
        else if (buttonType === 4) {
            setModalLogo(calculationsLogo); // Set JSX element for the logo
            setModalTitle("Calculation References");
            setShowFooterButtonModal(true);
            console.log("calculation references");
        }
    };
    const handleRedirect = () => {
      const id = selectedDrug?.moleculeId || selectedDrug?.vpId;
      const name = selectedDrug?.vpName ?? '';
      const type = selectedDrug?.moleculeId ? "molecule" : "vp";

      if (id) {
          history.push(`/druginteractions?id=${id}&name=${encodeURIComponent(name)}&type=${type}`);
      } else {
          console.warn("No valid ID found for selected drug.");
      }
    };

    
    const [showFooterButtonModal, setShowFooterButtonModal] = useState(false);
    function FooterButtonModal(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="resultsModal"
                dialogClassName={isLgScreen ? "" : "modal-dialog-scrollable"}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center flex-nowrap w-100">
                        {modalLogo}
                        <h5 className="mb-0" style={{fontSize: !isLgScreen ? 16:""}}  >{modalTitle}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {footerButtonType === 1 ? (
                        isModalDataLoading ? (
                            <Box display="flex" justifyContent="center" alignItems="center" minHeight="150px">
                                <CircularProgress />
                            </Box>
                        ) : (
                            modalBody 
                        )
                    ) : footerButtonType === 2 ? (
                      <>
                        <h5>Pregnancy:</h5>
                        <div>{selectedDrug?.pregnancyInfo?.replaceAll("\\r\\n", " ")}</div>
                        <br />
                        <h5>Lactation:</h5>
                        <div>{selectedDrug?.lactaionInfo?.replaceAll("\\r\\n", " ")}</div>
                      </>
                    ) : footerButtonType === 3 ? (
                        <>
                            {selectedPatient.prescriptionCalculation.map((presCal, idx) => {
                                const lines = presCal.pcCalculation.split("\\r\\n");
                                const lastLine = lines[lines.length - 1];

                                return (
                                    <Box key={idx} mb={2}>
                                        <Typography variant="subtitle2" sx={{ textDecoration: "underline" }}>
                                            {presCal.pcTitle}
                                        </Typography>

                                        {lines.slice(0, -1).map((line, i) => (
                                            <Typography variant="body2" key={i}>
                                                {line}
                                            </Typography>
                                        ))}

                                        {lastLine === "See references" || lastLine === "See reference" ? (
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    textDecoration: "underline",
                                                    color: theme.primary,
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                    mt:2,
                                                    textTransform: "Uppercase"
                                                }}
                                                onClick={() => {
                                                  setShowFooterButtonModal(false);
                                                  handleFooterButtons(4); // Trigger the specific action for button type 4
                                              }}
                                            >
                                                {lastLine}
                                            </Typography>
                                        ) : (
                                            <Typography variant="body2">{lastLine}</Typography>
                                        )}
                                    </Box>
                                );
                            })}
                        </>
                    ) : footerButtonType === 4 ? (
                        <>
                            <ul style={{ paddingLeft: isLgScreen ? 32 : 16, listStyleType: 'disc', margin: 0 }}>
                                {selectedPatient.calculationReference
                                    .split("\\r\\n")
                                    .filter(Boolean) // Remove empty lines
                                    .map((item, index) => {
                                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                                        const cleanedItem = item.replaceAll('\\"', '').replace(/^\s*[-•*]\s*/, '');
                                        const parts = cleanedItem.split(urlRegex);

                                        return (
                                            <li key={index}>
                                                {parts.map((part, i) => {
                                                    const isUrl = urlRegex.test(part);
                                                    const cleanedUrl = isUrl ? part.replace(/[.,!?;]$/, '') : part;

                                                    return isUrl ? (
                                                        <a key={i} href={cleanedUrl} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>
                                                            {cleanedUrl}
                                                        </a>
                                                    ) : (
                                                        <span key={i}>{part}</span>
                                                    );
                                                })}
                                            </li>
                                        );
                                    })}
                            </ul>
                        </>
                    ) : <h5 style={{lineHeight: 1.5}}>Would you like to check interactions for <span style={{ fontWeight: "bold", color: theme.primary }}>{vpName}</span>?</h5>

                    }
                </Modal.Body>
                {footerButtonType === 0 && ( <>
                <Modal.Footer style={{ display: "flex", gap: "8px", width: "100%", flexWrap: "wrap", paddingTop: "20px" }}>
                
                  <Button
                  variant="text"
                  onClick={() => setShowFooterButtonModal(false)}
                  sx={{
                      flex: 1,
                      borderRadius: "12px",
                      padding: "12px",
                      minWidth: "fit-content",
                      whiteSpace: "nowrap",
                      color: 'text.secondary',
                      fontWeight: "bold"
                  }}
                  >
                  Cancel
                  </Button>
                
                  <Button
                      variant="contained"
                      type="submit"
                      onClick={handleRedirect}
                      sx={{
                      flex: 1,
                      borderRadius: "12px",
                      minWidth: "fit-content",
                      padding: "12px",
                      backgroundColor: theme.primary,
                      whiteSpace: "nowrap"
                      }}
                      startIcon={<IconZoomCheckFilled />}
                  >
                      Proceed
                  </Button>
                </Modal.Footer>
                </> )}
            </Modal>
        );
    }
    
    const [adminRoute, setadminRoute] = useState('')
    const [Prescriptionguideline, setPrescriptionguideline] = useState('')
    const [pctitle, setpctitle] = useState('')
    const [pcCalculation, setpcCalculation] = useState('')
    const [calculationReference, setcalculationReference] = useState('')
    function Patientclass(event) {
        if (event !== null) {
            //console.log(data);
            setadminRoute(event.target.selectedOptions[0].getAttribute('data-route'));
            setPrescriptionguideline(event.target.selectedOptions[0].getAttribute('data-prescriptionguideline'));
            setpctitle(event.target.selectedOptions[0].getAttribute('data-pctitle'));
            setpcCalculation(event.target.selectedOptions[0].getAttribute('data-pccalculation'));
            setcalculationReference(event.target.selectedOptions[0].getAttribute('data-calculationreference'));
        };
    }
    //console.log(data);
    const [showGuidline, setShowGuideline] = useState(false)
    const onClickshowGuidline = () => setShowGuideline(true)


    
      
    //Make patient classification float after scrolling
    const sentinelRef = useRef(null);
    const [isFloating, setIsFloating] = useState(false);
    useEffect(() => {
        if (!isLgScreen) {
            setIsFloating(false);
            return;
        }
            
        const observer = new IntersectionObserver(
        ([entry]) => {
            setIsFloating(!entry.isIntersecting);
        },
        {
            root: null,
            threshold: 0,
        }
        );

        if (sentinelRef.current) {
        observer.observe(sentinelRef.current);
        }

        return () => {
        if (sentinelRef.current) {
            observer.unobserve(sentinelRef.current);
        }
        };
        
    }, [isLgScreen]);
        // const [isFloating, setIsFloating] = useState(false);
        // useEffect(() => {
        //     const handleScroll = () => {
                
        
        //         if (window.scrollY > 300 && isLgScreen) {
        //             if (!isFloating) setIsFloating(true);
        //         } else {
        //             if (isFloating) setIsFloating(false);
        //         }
        //     };
        
        //     window.addEventListener("scroll", handleScroll);
        //     return () => window.removeEventListener("scroll", handleScroll);
        // }, [isFloating]);

 
      
      const [expandedDosing, setExpandedDosing] = useState(null);
      const [expandedRef, setExpandedRef] = useState(null);
    
      const toggleDosing = (index) => {
        setExpandedDosing(expandedDosing === index ? null : index);
      };
    
      const toggleReference = (index) => {
        setExpandedRef(expandedRef === index ? null : index);
      };
      const [selectedPatient, setSelectedPatient] = useState(null);
      const [isDataLoading, setIsDataLoading] = useState(true);
      
    
    
      const listRef = useRef(null);
      useEffect(() => {
        if (listRef.current) {
          listRef.current.scrollTop = 0;
        }
      }, [doseId]);
      
    const muiTheme = useTheme();
    const transitionDuration = {
        enter: muiTheme.transitions.duration.enteringScreen,
        exit: muiTheme.transitions.duration.leavingScreen,
    };
    const handleScrollUp = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    };
    console.log(Object.keys(groupedPatients));
    const groupRefs = useRef({});
    const [expandedAccordions, setExpandedAccordions] = useState({
        panel1: false,
        panel2: false,
      });
    
      
    return (
        <>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <FooterButtonModal
            show={showFooterButtonModal}
            onHide={() => setShowFooterButtonModal(false)}
        />
        <Banner />
        <Sidebar activeButton={activeButton} />
        <div id="DosingCalculations">
            <Container fluid id="main">
                <div id="content">
                    <div id="contentCaption">
                        <h2>Dosing Calculations</h2>
                        {isLgScreen && (
                            <span>Recommended dosages for prescribing of medicines in dentistry for adults and children.</span>
                        )}
                    </div>
                    
                    <Row id="drugList" className={ isLgScreen ? 'my-3 d-flex flex-row' : 'mt-4 d-flex flex-row'}>
                        <div className='d-flex p-0' style={{color: theme.primary}}>
                            <IconPillFilled style={{marginRight: 8}}/>
                            <h5 style={{ fontWeight: "bold", marginBottom: "12px", }}>
                                DRUG LIST
                            </h5>
                        </div>
                        {isLoading ? (
                        <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "12px" }} />
                        ) : (
                        <Autocomplete
                            options={filteredOptions}
                            blurOnSelect
                            focused
                            getOptionLabel={(option) => option.name || ''}
                            value={
                            filteredOptions.length && doseId
                                ? filteredOptions.find(option => option.id === doseId)
                                : null
                            }
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    handleDoseSelection(newValue); // <-- reuse here
                                    setExpandedAccordions({
                                        panel1: false,
                                        panel2: false,
                                    });
                                }
                            }}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Choose a drug for dosage info"
                                InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <>
                                    <InputAdornment position="start">
                                        <IconSearch size={20} />
                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                    </>
                                ),
                                endAdornment: (
                                    <>
                                    {isLoading ? <CircularProgress size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                    </>
                                ),
                                }}
                                inputProps={{
                                  ...params.inputProps,
                                  style: selectedDrug ? { fontWeight: 'bold', color: theme.primary } : {}, // apply only if selected
                                }}
                            />
                            )}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        />
                        )}
                        <div ref={sentinelRef} style={{ height: '1px' }}></div>
                    </Row>
                    <Row id="dosingContainer">
                    {doseId ? (
                        <>
                        <Col
                          xs={12}
                          md={12}
                          lg={4}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            borderRight: isLgScreen ? '1px solid #e3e3e3': "none",
                            padding: isLgScreen ? 24 : 0,
                            minHeight: isFloating ? '516px' : 'auto',
                            height: 'auto',
                          }}
                        >
                          {isLgScreen ? (
                            <>
                              {isFloating && (
                                <div style={{ height: 516, width: '100%' }} /> // Same as .floating height
                              )}
                              <div
                                className={isFloating ? 'floating' : ''}
                                style={{
                                  top: isFloating ? '66px' : '40px',
                                  transition: 'top 0.2s ease',
                                }}
                              >
                                <div style={{ flex: 1 }}>
                                  <h5
                                    style={{
                                      fontWeight: 'bold',
                                      color: '#202020',
                                      marginLeft: '2px',
                                    }}
                                  >
                                    PATIENT CLASSIFICATION:
                                  </h5>
                                  <Box
                                    ref={listRef}
                                    sx={{
                                      minHeight: 160,
                                      maxHeight: 'calc(100vh - 200px)',
                                      height: 'auto',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      boxShadow: 'none',
                                      p: 0,
                                      overflow: 'auto',
                                      borderRadius: 2,
                                      position: 'relative',
                                    }}
                                  >
                                    <List disablePadding>
                                      {Object.entries(groupedPatients).map(([groupName, items], index) => {
                                        const topOffset = index * 40;
                                        return (
                                          <React.Fragment key={groupName}>
                                            {Object.values(groupedPatients).flat().length > 1 && (
                                              <>
                                                <div
                                                  ref={(el) => {
                                                    if (el) groupRefs.current[groupName] = el;
                                                  }}
                                                  style={{
                                                    position: 'relative',
                                                    top: `-${topOffset}px`,
                                                  }}
                                                />
                                                <ListSubheader
                                                  onClick={() => {
                                                    groupRefs.current[groupName]?.scrollIntoView({
                                                      behavior: 'smooth',
                                                      block: 'start',
                                                    });
                                                  }}
                                                  component="div"
                                                  sx={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    fontSize: 12,
                                                    color: '#b1b1b1',
                                                    my: 0,
                                                    textTransform: 'uppercase',
                                                    position: 'sticky',
                                                    top: `${topOffset}px`,
                                                    zIndex: 4,
                                                    lineHeight: '40px',
                                                    px: 0,
                                                    background: 'transparent',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    '&:hover': {
                                                      textDecoration: 'underline',
                                                      color: '#71717a',
                                                    },
                                                  }}
                                                >
                                                  {/* Circle */}
                                                  <Box
                                                    sx={{
                                                      width: 10,
                                                      height: 10,
                                                      bgcolor: '#ffffff',
                                                      border: '1px solid #cbd5e1',
                                                      borderRadius: '50%',
                                                      zIndex: 5,
                                                      ml: 0,
                                                    }}
                                                  />
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      width: '100%',
                                                      background: 'white',
                                                      px: 1,
                                                      ml: 0,
                                                    }}
                                                  >
                                                    {groupName.toUpperCase()}
                                                  </Box>
                                                </ListSubheader>
                                              </>
                                            )}

                                            {/* Vertical line */}
                                            <Box
                                              sx={{
                                                position: 'absolute',
                                                left: 4,
                                                top: `${topOffset}px`,
                                                bottom: 0,
                                                width: '1px',
                                                bgcolor: '#cbd5e1',
                                                zIndex: 0,
                                              }}
                                            />

                                            {/* List Items */}
                                            {items.map((val) => (
                                               <ListItem
                                               key={val.id}
                                               disablePadding
                                               sx={{
                                                 my: 0,
                                                 position: 'relative',
                                                 zIndex: 2,
                                                 borderRadius: '16px',
                                                 width: 'auto',
                                                 mx: 2,
                                                 py: '4px',
                                               }}
                                             >
                                               <ListItemButton
                                                 onClick={() => {
                                                   setExpandedAccordions({
                                                     panel1: false,
                                                     panel2: false,
                                                   });
                                                   handlePatientClassificationChange(val);
                                                 }}
                                                 selected={selectedPatient?.id === val.id}
                                                 sx={{
                                                  
                                                   borderRadius: '16px',
                                                   '&.Mui-selected': {
                                                   bgcolor: theme.primary,
                                                   color: 'white',
                                                   fontWeight: 'bold',
                                                   pointerEvents: selectedPatient?.id === val.id ? 'none' : 'auto', // Prevent clicking on selected item
                                                   
                                                   },
                                                   '&.Mui-selected:hover': {
                                                   bgcolor: theme.primary,
                                                   },
                                                   '&.Mui-selected .MuiListItemText-primary': {
                                                   fontWeight: 'bold',
                                                   },
                                               }}
                                               >
                                                  <ListItemText
                                                    primary={val.patientCaterory}
                                                    primaryTypographyProps={{
                                                      fontSize: 16,
                                                      fontWeight:
                                                        selectedPatient?.id === val.id ? 'bold' : 'normal',
                                                    }}
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            ))}
                                          </React.Fragment>
                                        );
                                      })}
                                    </List>
                                  </Box>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                            {isDataLoading ? (<Skeleton width="100%" height="56px" />):(
                              <>
                              <hr className="my-3"style={{borderColor: "#727272"}}/>
                            <FormControl fullWidth>
                              <InputLabel
                                htmlFor="grouped-native-select"
                                style={{ fontWeight: "bold", color: "#202020", }} // shift to account for icon
                              >
                                Select Patient
                              </InputLabel>

                              <Box sx={{ position: "relative" }}>
                                <IconUserSquareRounded
                                  size={22}
                                  style={{
                                    position: "absolute",
                                    top: '50%',
                                    left: 9,
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none',
                                    color: '#757575'
                                  }}
                                />

                                <Select
                                  native
                                  value={selectedPatient?.id || ""}
                                  onChange={(e) => {
                                    const selectedId = e.target.value;
                                    const selected = Object.values(groupedPatients)
                                      .flat()
                                      .find((p) => p.id.toString() === selectedId);
                                    if (selected) {
                                      setExpandedAccordions({ panel1: false, panel2: false });
                                      handlePatientClassificationChange(selected);
                                    }
                                  }}
                                  inputProps={{
                                    id: 'grouped-native-select',
                                    style: {
                                      paddingLeft: 42, // padding to make space for the icon
                                    }
                                  }}
                                  label="Select Patient"
                                  fullWidth
                                >
                                  {Object.entries(groupedPatients).map(([groupName, items]) => (
                                    <optgroup key={groupName} label={groupName.toUpperCase()}>
                                      {items.map((val) => (
                                        <option key={val.id} value={val.id}>
                                          {val.patientCaterory}
                                        </option>
                                      ))}
                                    </optgroup>
                                  ))}
                                </Select>
                              </Box>
                            </FormControl>
                            </> )}
                            </>
                          )}
                        </Col>

                        <Col xs={12} md={12} lg={8} style={{padding: isLgScreen ? "20px 32px 32px 32px" : "20px 8px 20px 8px"}}>
                            <Box>
                                {selectedPatient && (
                                    <>
                                   
                                {/* // <Paper elevation={1} sx={{ p: 2 }}> */}
                                    <h3 style={{fontWeight: "bold", color: theme.primary }}>{vpName}</h3>

                                    <Box sx={{ mt: 2 }}>
                                        <Row className="my-3">
                                            <Col lg={6} md={12} xs={12} className="d-flex flex-column" style={{marginBottom: !isLgScreen ? 16 : ""}}>
                                            <strong style={{ color: "#727272", fontSize: 12, marginBottom: "8px" }}>
                                                Patient Category
                                            </strong>
                                            <span style={{ color: "#202020", fontSize: 16, fontWeight: "bold" }}>
                                                {isDataLoading ? <Skeleton width="100px" /> : selectedPatient.patientCaterory}
                                            </span>
                                            </Col>
                                            <Col lg={6} md={12} xs={12} className="d-flex flex-column">
                                            <strong style={{ color: "#727272", fontSize: 12, marginBottom: "8px" }}>
                                                Route Of Administration
                                            </strong>
                                            <span style={{ color: "#202020", fontSize: 16 }}>
                                                {isDataLoading ? <Skeleton width="100px" /> : selectedPatient.routeOfAdmin}
                                            </span>
                                            </Col>
                                        </Row>
                                        <Col lg={12} className="d-flex flex-column mb-4">
                                            <strong style={{ color: "#727272", fontSize: 12, marginBottom: "8px" }}>
                                            Suggested Prescription:
                                            </strong>
                                            <span style={{ color: "#202020", fontSize: 16 }}>
                                            {isDataLoading ? <Skeleton width="100%" /> : selectedPatient.prescriptionDescription}
                                            </span>
                                        </Col>

                                        {/* Dose Calculations Accordion */}
                                        {isDataLoading ? (
                                          <Skeleton height={60} />
                                        ) : (
                                          // For larger screens, render as Accordion
                                          isLgScreen ? (
                                            selectedPatient.prescriptionCalculation?.some(e => e.pcCalculation.trim() !== "") && (
                                              <Accordion
                                                expanded={expandedAccordions.panel1}
                                                onChange={(e, isExpanded) =>
                                                  setExpandedAccordions((prev) => ({ ...prev, panel1: isExpanded }))
                                                }
                                                disableGutters
                                                square
                                                sx={{
                                                  mt: 2,
                                                  boxShadow: "none",
                                                  borderRadius: "12px",
                                                  border: "1px solid #e3e3e3",
                                                  "&::before": { display: "none" },
                                                }}
                                              >
                                                <AccordionSummary expandIcon={<IconCaretDownFilled />}>
                                                  <Typography sx={{ fontSize: 12, fontWeight: "bold", color: "#727272" }}>
                                                    <IconInfoCircleFilled size={20} style={{ marginRight: 8, verticalAlign: "middle", color: theme.primary }} />
                                                    Dose Calculations
                                                  </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ pl: 2 }}>
                                                  {selectedPatient.prescriptionCalculation.map((presCal, idx) => {
                                                    const lines = presCal.pcCalculation.split("\\r\\n");
                                                    const lastLine = lines[lines.length - 1];

                                                    return (
                                                      <Box key={idx} mb={2}>
                                                        <Typography variant="subtitle2" sx={{ textDecoration: "underline" }}>
                                                          {presCal.pcTitle}
                                                        </Typography>

                                                        {lines.slice(0, -1).map((line, i) => (
                                                          <Typography variant="body2" key={i}>
                                                            {line}
                                                          </Typography>
                                                        ))}

                                                        {lastLine === "See references" || lastLine === "See reference" ? (
                                                          <Typography
                                                            variant="body2"
                                                            sx={{
                                                              textDecoration: "underline",
                                                              color: theme.primary,
                                                              cursor: "pointer",
                                                              fontWeight: "bold",
                                                              mt:2,
                                                              textTransform: "Uppercase"
                                                            }}
                                                            onClick={() =>
                                                              setExpandedAccordions((prev) => ({
                                                                ...prev,
                                                                panel2: true,
                                                              }))
                                                            }
                                                          >
                                                            {lastLine}
                                                          </Typography>
                                                        ) : (
                                                          <Typography variant="body2">{lastLine}</Typography>
                                                        )}
                                                      </Box>
                                                    );
                                                  })}
                                                </AccordionDetails>
                                              </Accordion>
                                            )
                                          ) : (
                                            // For smaller screens, render as Button
                                            selectedPatient.prescriptionCalculation?.some(e => e.pcCalculation.trim() !== "") && (
                                              <Button
                                          fullWidth
                                          variant="outlined"
                                          sx={{
                                            mt: 2,
                                            display: 'flex',
                                            justifyContent: 'space-between', // Spaces out the left and right elements
                                            alignItems: 'center', // Aligns the icons and text vertically
                                            fontWeight: 600,
                                            textTransform: "none",
                                            p:2,
                                            borderRadius: "12px",
                                            borderColor: "#e3e3e3"
                                          }}
                                          onClick={() => handleFooterButtons(3)}
                                        >
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <IconInfoCircleFilled color={theme.primary} size={20} style={{ marginRight: 8 }} />
                                            <span style={{color: "#727272", fontSize: 12}}> Dose Calculations </span>
                                          </Box>
                                          <IconExternalLink color="#727272" size={20} />
                                        </Button>

                                            )
                                          )
                                        )}

                                        {isDataLoading ? (
                                          <Skeleton height={60} />
                                        ) : (
                                          // For larger screens, render as Accordion
                                          isLgScreen ? (
                                            selectedPatient.calculationReference && (
                                              <Accordion
                                                expanded={expandedAccordions.panel2}
                                                onChange={(e, isExpanded) =>
                                                  setExpandedAccordions((prev) => ({ ...prev, panel2: isExpanded }))
                                                }
                                                disableGutters
                                                square
                                                sx={{
                                                  mt: 2,
                                                  boxShadow: "none",
                                                  borderRadius: "12px",
                                                  border: "1px solid #e3e3e3",
                                                  "&::before": { display: "none" },
                                                }}
                                              >
                                                <AccordionSummary expandIcon={<IconCaretDownFilled />}>
                                                  <Typography sx={{ fontSize: 12, fontWeight: "bold", color: "#727272" }}>
                                                    <IconInfoCircleFilled size={20} style={{ marginRight: 8, verticalAlign: "middle", color: theme.primary }} />
                                                    Calculation References
                                                  </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ pl: 2 }}>
                                                  <ul style={{ paddingLeft: isLgScreen ? 32 : 16, listStyleType: 'disc', margin: 0 }}>
                                                    {selectedPatient.calculationReference
                                                      .split("\\r\\n")
                                                      .filter(Boolean) // 👈 Remove empty lines
                                                      .map((item, index) => {
                                                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                                                        const cleanedItem = item.replaceAll('\\"', '').replace(/^\s*[-•*]\s*/, '');
                                                        const parts = cleanedItem.split(urlRegex);

                                                        return (
                                                          <li key={index}>
                                                            {parts.map((part, i) => {
                                                              const isUrl = urlRegex.test(part);
                                                              const cleanedUrl = isUrl ? part.replace(/[.,!?;]$/, '') : part;

                                                              return isUrl ? (
                                                                <a key={i} href={cleanedUrl} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>
                                                                  {cleanedUrl}
                                                                </a>
                                                              ) : (
                                                                <span key={i}>{part}</span>
                                                              );
                                                            })}
                                                          </li>
                                                        );
                                                      })}
                                                  </ul>
                                                </AccordionDetails>
                                              </Accordion>
                                            )
                                          ) : (
                                            // For smaller screens, render as Button
                                            selectedPatient.calculationReference && (
                                              <Button
                                              fullWidth
                                              variant="outlined"
                                              sx={{
                                                mt: 2,
                                                display: 'flex',
                                                justifyContent: 'space-between', // Spaces out the left and right elements
                                                alignItems: 'center', // Aligns the icons and text vertically
                                                fontWeight: 600,
                                                textTransform: "none",
                                                p:2,
                                                borderRadius: "12px",
                                                borderColor: "#e3e3e3"
                                              }}
                                              onClick={() => handleFooterButtons(4)}
                                            >
                                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <IconInfoCircleFilled color={theme.primary} size={20} style={{ marginRight: 8 }} />
                                                <span style={{color: "#727272", fontSize: 12}}> Calculation References </span>
                                              </Box>
                                              <IconExternalLink color="#727272" size={20} />
                                            </Button>
                                            )
                                          )
                                        )}

                                    </Box>

                                    
                                    <hr style={{borderColor: "#727272"}}/>
                                    <div className='d-flex flex-column' style={{ gap: isLgScreen ? undefined : 12, flexWrap: 'nowrap' }}>
                                    <strong style={{ color: "#727272", fontSize: 12, whiteSpace: 'nowrap'}}>
                                                See also:
                                            </strong>
                                            {isLgScreen ? (
                                              <div className="d-flex" style={{ gap: 16, marginTop: 12 }}>
                                                <Button
                                                  variant="contained"
                                                  fullWidth
                                                  onClick={() => handleFooterButtons(0)}
                                                  sx={{
                                                    py: 1,
                                                    px: 2,
                                                    bgcolor: theme.primary,
                                                    color: "#fff",
                                                    borderRadius: '12px',
                                                    textTransform: "none",
                                                    fontSize: 12
                                                  }}
                                                  startIcon={
                                                    <img
                                                      src="/MenuIcons/Active/SVG/Interactions.svg"
                                                      alt="icon"
                                                      style={{ width: 20, height: 20 }}
                                                    />
                                                  }
                                                >
                                                  Drug & Allergy Interactions
                                                </Button>

                                                <Button
                                                  variant="contained"
                                                  fullWidth
                                                  onClick={() => handleFooterButtons(1)}
                                                  sx={{
                                                    py: 1,
                                                    px: 2,
                                                    bgcolor: theme.primary,
                                                    color: "#fff",
                                                    borderRadius: '12px',
                                                    textTransform: "none",
                                                    fontSize: 12
                                                  }}
                                                  startIcon={
                                                    <img
                                                      src="/Contraindication.svg"
                                                      alt="icon"
                                                      style={{ width: 20, height: 20 }}
                                                    />
                                                  }
                                                >
                                                  Contraindications & Precautions
                                                </Button>

                                                <Button
                                                  variant="contained"
                                                  fullWidth
                                                  onClick={() => handleFooterButtons(2)}
                                                  sx={{
                                                    py: 1,
                                                    px: 2,
                                                    bgcolor: theme.primary,
                                                    color: "#fff",
                                                    borderRadius: '12px',
                                                    textTransform: "none",
                                                    fontSize: 12
                                                  }}
                                                  startIcon={
                                                    <img
                                                      src="/MenuIcons/Active/SVG/Pregnancy.svg"
                                                      alt="icon"
                                                      style={{ width: 20, height: 20 }}
                                                    />
                                                  }
                                                >
                                                  Pregnancy & Lactation
                                                </Button>
                                              </div>
                                            ) : (
                                              <div className="d-flex">
                                              <ButtonGroup fullWidth variant="contained" aria-label="Basic button group" sx={{borderRadius: "12px", borderColor: "#ffffff"}}>
                                              <Button 
                                                  onClick={() => handleFooterButtons(0)}
                                                  sx={{ py: "12px", borderRadius: "12px", bgcolor: theme.primary, border: "1px solid #fffff" }}><img
                                                    src="/MenuIcons/Active/SVG/Interactions.svg"
                                                    alt="Interactions"
                                                    style={{ width: 24, height: 24 }}
                                                  /></Button>
                                              <Button 
                                                  onClick={() => handleFooterButtons(1)}
                                                  sx={{ py: "12px", borderRadius: "12px", bgcolor: theme.primary, border: "1px solid #fffff" }}><img
                                                      src="/Contraindication.svg"
                                                      alt="icon"
                                                      style={{ width: 24, height: 24 }}
                                                    /></Button>
                                              <Button 
                                                  onClick={() => handleFooterButtons(2)}
                                                  sx={{ py: "12px", borderRadius: "12px", bgcolor: theme.primary, border: "1px solid #fffff" }}><img
                                                      src="/MenuIcons/Active/SVG/Pregnancy.svg"
                                                      alt="icon"
                                                      style={{ width: 24, height: 24 }}
                                                    /></Button>
                                            </ButtonGroup>
                                            </div>

                                            )}

                                        </div>
                                    </>
                                // </Paper>
                                )}
                            </Box>
                        </Col>
                        </>
                        ) : ( 
                        <div style={{ textAlign: 'center', padding: isLgScreen ? '20px' : 0, marginTop: !isLgScreen? 20 :"" }}>
                            <div id="illustration-container" >
                                <h6 style={{lineHeight: 1.5}}>SELECT FROM THE DRUG LIST TO VIEW DOSAGE RECOMMENDATIONS.</h6>
                                <img src={country === "New Zealand" ? IllustrationNZ : Illustration} alt="Illustration" id="illustration" style={{ maxWidth: '100%', height: 'auto' }} />
                            </div>
                        </div>
                        )}
                    </Row>
                </div>
                <Zoom
                  in={isFloating && isLgScreen}
                  timeout={transitionDuration}
                  unmountOnExit
                  >
                    <Fab
                        color="primary"
                        aria-label="add"
                        sx={{
                        position: 'fixed',
                        bottom: 40,
                        right: 40,
                        zIndex: 100,
                        backgroundColor: theme.primary
                        }}
                        variant="extended"
                        onClick={handleScrollUp}
                        size="medium"
                    >
                            <IconArrowBadgeUpFilled sx={{ mr: 2 }} />
                            Scroll Up
                    </Fab>
                </Zoom>
            </Container>
        </div>
         </>
 );
}

export default DosingCalculations;